import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  visible: false,
  isSubmitting: false,
  campaignId: null,
  adGroupId: null,
  campaigns: [],
  adGroups: [],
  campaignLoading: false,
  adGroupLoading: false,
}

export const showAdGroupSelect = createAxiosThunk(
  'dashboard/adGroupSelect/fetchCampaigns',
  () => api.ad.getNotDeletedCampaigns()
)

export const fetchAdGroups = createAxiosThunk(
  'dashboard/adGroupSelect/fetchAdGroups',
  campaignId => api.ad.getCampaignNotDeletedAdGroups(campaignId)
)

export const adGroupSelectSlice = createSlice({
  name: 'dashboard/adGroupSelect',
  initialState,

  reducers: {
    hideAdGroupSelect: () => initialState,
    setCampaignId: (state, { payload: campaignId }) => {
      state.campaignId = campaignId
      state.adGroupId = null
      state.adGroups = []
    },
    setAdGroupId: (state, { payload: adGroupId }) => {
      state.adGroupId = adGroupId
    },
  },

  extraReducers: builder => {
    builder.addCase(showAdGroupSelect.pending, state => {
      state.campaignLoading = true
      state.visible = true
    })

    builder.addCase(
      showAdGroupSelect.fulfilled,
      (state, { payload: { campaigns } }) => {
        state.campaigns = campaigns
        state.campaignLoading = false
      }
    )

    builder.addCase(showAdGroupSelect.rejected, state => {
      state.campaignLoading = false
    })

    builder.addCase(fetchAdGroups.pending, state => {
      state.adGroupLoading = true
    })

    builder.addCase(
      fetchAdGroups.fulfilled,
      (state, { payload: { adGroupDtos } }) => {
        state.adGroups = adGroupDtos
        state.adGroupLoading = false
      }
    )

    builder.addCase(fetchAdGroups.rejected, state => {
      state.adGroupLoading = false
    })
  },
})

export const { hideAdGroupSelect, setCampaignId, setAdGroupId } =
  adGroupSelectSlice.actions
export default adGroupSelectSlice.reducer
